import { render, staticRenderFns } from "./PathogenChart.vue?vue&type=template&id=71f61ad4&scoped=true"
import script from "./PathogenChart.vue?vue&type=script&lang=ts"
export * from "./PathogenChart.vue?vue&type=script&lang=ts"
import style0 from "./PathogenChart.vue?vue&type=style&index=0&id=71f61ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f61ad4",
  null
  
)

export default component.exports